<div class="alerts-wrap">
  <edgvr-front-ui-notification
    [notification]="notification"
    (closeNotification)="onCloseNotification($event)"
    *ngFor="let notification of notifications"
    class="alerts-item"
  ></edgvr-front-ui-notification>
</div>
